<template>
    <div class="licence__list_table">
        <component-table
            :labels="[
                {
                    key: 'createdAt',
                    title: 'Created on',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'courseName',
                    title: 'Course name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'customer',
                    title: 'Customer',
                    type: 'string'
                },
                {
                    key: 'numberOfLicences',
                    title: 'Total',
                    type: 'number',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'left',
                    title: 'Left',
                    type: 'number'
                },
                {
                    key: 'used',
                    title: 'Used',
                    type: 'number'
                },
                {
                    key: 'validFromDate',
                    title: 'Start date',
                    type: 'date',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'validToDate',
                    title: 'Expiry date',
                    type: 'date',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'status',
                    title: 'Status',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'actions',
                    title: '',
                    type: 'string'
                }
            ]"
            :items="items"
            :component-table-item="LicenceListTableItem"
            :sort-queryable="sortQueryable"
            @emit-sort="handleSort"
            @emit-suspend="openNotifySuspendLicence"
            @emit-restore="openNotifyRestoreLicence"
            @emit-archive="openNotifyArchiveLicence"
        />
        <pop-notify
            ref="notifysuspendoffer"
            :class="'pop__notify--suspend'"
            :title-text="'Suspend offer?'"
            :content-text="'Suspending this offer will prevent the organisation from accessing this course.\n Please give a reason for why you are suspending the offer.'"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Ok'"
            :submit-button-animate-loading="true"
            :prevent-close="true"
            :size="'medium'"
            @emit-submit="performSuspendLicence"
        >
            <form-editor
                :name="'licence-list-table-notify-note-suspend'"
                v-model="licenceDescription"
            />
        </pop-notify>
        <pop-notify
            ref="notifyrestoreoffer"
            :class="'pop__notify--restore'"
            :title-text="'Restore offer?'"
            :content-text="'Restoring this offer will give the organisation access to this course again.\n Please give a reason for why you are restoring the offer.'"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Ok'"
            :submit-button-animate-loading="true"
            :prevent-close="true"
            :size="'medium'"
            @emit-submit="performRestoreLicence"
        >
            <form-editor
                :name="'licence-list-table-notify-note-restore'"
                v-model="licenceDescription"
            />
        </pop-notify>
        <pop-notify
            ref="notifyarchiveoffer"
            :class="'pop__notify--archive'"
            :title-text="'Archive offer?'"
            :content-text="'Archiving this offer will revoke the customers access to the course. \n\n You will not be able to restore the offer once it has been archived. \n\n The offer will still be visible to you in your licence table. \n\n Would you like to archive this offer?'"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Yes'"
            :submit-button-danger="true"
            :submit-button-animate-loading="true"
            :prevent-close="true"
            @emit-submit="performArchiveLicence"
        >
        </pop-notify>
    </div>
</template>

<script>
import LicenceListTableItem from '@/components/ebs/licences/list/LicenceListTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'
import PopNotify from '@/components/default/shared/PopNotify'
import FormEditor from '@/components/default/forms/FormEditor'

export default {
  components: {
    FormEditor,
    PopNotify,
    ComponentTable
  },
  name: 'licence-list-table',
  data () {
    return {
      LicenceListTableItem
    }
  },
  computed: {
    licenceDescription: {
      get () {
        return this.$store.getters.getEbsLicenceCustomDescription
      },
      set (value) {
        this.$store.dispatch('ebsLicenceSetCustomDescription', value)
      }
    }
  },
  props: {
    items: {
      type: [Array, Object]
    },
    sortQueryable: {
      type: Boolean
    }
  },
  methods: {
    handleSort (data) {
      this.$emit('emit-sort', data)
    },
    openNotifySuspendLicence (data) {
      this.licenceDescription = ''
      this.$refs.notifysuspendoffer.setStoreValue(data)
      this.$refs.notifysuspendoffer.openNotify()
    },
    openNotifyRestoreLicence (data) {
      this.licenceDescription = ''
      this.$refs.notifyrestoreoffer.setStoreValue(data)
      this.$refs.notifyrestoreoffer.openNotify()
    },
    openNotifyArchiveLicence (data) {
      this.licenceDescription = ''
      this.$refs.notifyarchiveoffer.setStoreValue(data)
      this.$refs.notifyarchiveoffer.openNotify()
    },
    performSuspendLicence () {
      const licenceId = this.$refs.notifysuspendoffer.storeValue
      this.$store.dispatch('ebsLicenceSuspend', licenceId).then(() => {
        this.$emit('emit-perform-get-items')
      }).finally(() => {
        this.$refs.notifysuspendoffer.closeNotify()
      })
    },
    performRestoreLicence () {
      const licenceId = this.$refs.notifyrestoreoffer.storeValue
      this.$store.dispatch('ebsLicenceRestore', licenceId).then(() => {
        this.$emit('emit-perform-get-items')
      }).finally(() => {
        this.$refs.notifyrestoreoffer.closeNotify()
      })
    },
    performArchiveLicence () {
      const licenceId = this.$refs.notifyarchiveoffer.storeValue
      this.$store.dispatch('ebsLicenceArchive', licenceId).then(() => {
        this.$emit('emit-perform-get-items')
      }).finally(() => {
        this.$refs.notifyarchiveoffer.closeNotify()
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/licences/licencelisttable";
</style>
